module.exports = __webpack_public_path__ + "img/05平面圖.290a7d1a.jpg";